export default [
    {
        // img: "https://placekitten.com/300/300",
        id: 1,
        url: "https://rodrigowebdesigner.com/site/",
        nome: "Rodrigo Santana",
        cargo: "",
        empresa: "RW Rodrigo WebDesigner",
        txt: "Profissional excelente com muita experiência.",
    },
    {
        // img: "https://placekitten.com/300/300",
        id: 2,
        url: "https://seducinfo.com.br/",
        nome: "Vitor Augusto",
        cargo: "",
        empresa: "Seduc Informática",
        txt: "Se você procura uma agência comprometida e com resultados reais no Google Ads, recomendo a Awaken de olhos fechados.Anderson, dono da agência, é um profissional excepcional, sempre disponível, transparente e altamente qualificado. Ele expirou cada etapa da estratégia de forma clara, o que me deu total confiança no trabalho e os resultados foram impressionantes.",
    },
    {
        // img: "https://placekitten.com/300/300",
        id: 3,
        url: "https://clinicadetecta.com.br/",
        nome: "Cristiane Pineroli Bochnia",
        cargo: "Proprietária",
        empresa: "Clínica Detecta",
        txt: "Profissional atencioso, educado e prestativo. Com sua ajuda e sugestões conseguimos planejar investimento de nosso marketing digital. Super recomendo!",
    },
    {
        // img: "https://placekitten.com/300/300",
        id: 4,
        url: "https://galias.com.br/novo/",
        nome: "Robson",
        cargo: "",
        empresa: "Galiás Comunicação Digital",
        txt: "Tranquilidade e segurança! Trabalho com a Awaken há mais de 4 anos onde o Anderson é o responsável pelas campanhas de Google Ads e pela gestão do Google Meu Negócio dos meus clientes. Assim, posso afirmar que, nessa área, entrego que há de melhor para o mercado. Vlw e vamos em frente.",
    },
    {
        // img: "https://placekitten.com/300/300",
        id: 5,
        url: "https://mbetelimobiliaria.com.br/",
        nome: "Mateus Almeida",
        cargo: "",
        empresa: "MBetel Imobiliária",
        txt: "Uma empresa séria representada pelo Anderson que é um ótimo profissional, talentoso, sensível ao mercado, com visão e ideais impressionantes. Só tenho a agradecer pela parceria!",
    },
    {
        // img: "https://placekitten.com/300/300",
        id: 6,
        url: "https://nuna.com.br/",
        nome: "Adriana Samaan",
        cargo: "",
        empresa: "Nuna Marketing Imobiliário",
        txt: "Uma das melhores empresas de Google do Sul do país. Recomendo sem vacilar!",
    },
    {
        // img: "https://placekitten.com/300/300",
        id: 7,
        url: "https://www.agencialed.com.br/",
        nome: "Fabricio Vaccari",
        cargo: "",
        empresa: "Agência Led",
        txt: "Recomendamos. Muito profissional. Os resultados acontecem.",
    },
    {
        // img: "https://placekitten.com/300/300",
        id: 8,
        url: " https://bubbler.com.br/",
        nome: "César Benítez",
        cargo: "",
        empresa: "Bubbler Design",
        txt: "Quer bons resultados, atendimento exclusivo e retorno do investimento, Awaken é a solução #indico #qualidade #principalmenteresultados.",
    },
    {
        // img: "https://placekitten.com/300/300",
        id: 9,
        url: " https://www.instagram.com/luuanna.barbosaa/",
        nome: "Luana Barbosa",
        cargo: "",
        empresa: "",
        txt: "Excelente profissional, indico de olhos fechados! Trabalho sério e de qualidade.",
    },
]